module.exports = __webpack_public_path__ + "img/Galactapedia_Kruger_Intergalactic.5f49e831.png";